'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {
    SOLUTIONS_PAGE_BREAKPOINT_FOR_ICON_COLOR,
} from "../common/constants/solutions";
import Image, {StaticImageData} from "next/image";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import {useResponsive} from "@/app/[locale]/common/utils/hooks/useResponsive/useResponsive";
import {BUTTON_TEXTS} from "../common/constants/button";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {Link} from '@/i18n/routing';
import {useTranslations} from "next-intl";

export default function Page() {
    const t = useTranslations('SolutionsPage');

    const iconColor = useResponsive('white', 'black', SOLUTIONS_PAGE_BREAKPOINT_FOR_ICON_COLOR) as 'white' | 'black';

    return (
        <section className={s.solutions}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.SOLUTIONS')]} />
                <Title title={t('title')} />
                <div className={s.solutions_cardsContainer}>
                    {
                        t.raw('cardsData').map((item: {title: string, image: StaticImageData, href: string}, index: number) => (
                            <div key={index} className={s.solutions_card}>
                                <Link href={item.href} className={s.solutions_card_imageContainer}>
                                    <Image src={item.image.src} width={500} height={500} alt={'Slide Image' + index}/>
                                </Link>
                                <div className={s.solutions_card_content}>
                                    <p>{item.title}</p>
                                    <TextIconLink
                                        href={item.href}
                                        icon={<CircleArrowIcon color={iconColor}/>}
                                    >
                                        { BUTTON_TEXTS.INFO_LEARN_MORE }
                                    </TextIconLink>
                                </div>
                            </div>
                        ))
                    }
                </div>

                <ContactUs/>
            </Container>
        </section>
    );
};